import { render } from "./CancellationPolicy.vue?vue&type=template&id=3fa5f6fc"
import script from "./CancellationPolicy.vue?vue&type=script&lang=js"
export * from "./CancellationPolicy.vue?vue&type=script&lang=js"

import "./CancellationPolicy.vue?vue&type=style&index=0&id=3fa5f6fc&lang=css"

import exportComponent from "/home/github-runner/actions-runner/_work/acutame/acutame/src/main/front/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__